(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg_ifa-product-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-secondary-product-cards-script');
    if (!window.secondaryProductCards && $url) {
      window.secondaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.secondaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }

    var $url2 = document.querySelector('.as-info-carousel-script');
    if (!window.infoCarousel && $url2) {
      window.infoCarousel = $url2.value;
      var $script = document.createElement('script');
      $script.src = window.infoCarousel;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg_image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg_secondary-product-cards-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-secondary-product-cards-script');
    if (!window.secondaryProductCards && $url) {
      window.secondaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.secondaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }

    var $url2 = document.querySelector('.as-info-carousel-script');
    if (!window.infoCarousel && $url2) {
      window.infoCarousel = $url2.value;
      var $script = document.createElement('script');
      $script.src = window.infoCarousel;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-highlight-cards-script')
    if (!window.highlightCards && $url && $url.dataset.designMode !== 'yes') {
      window.highlightCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.highlightCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlights-replay"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadProductPromotionScript() {
    var hasBundle = Array.prototype.some.call(document.scripts || [], function (x) {
      return (
        x.src &&
        (x.src.indexOf('product-promotion.min.js') !== -1 || x.src.indexOf('image-cards.min.js') !== -1)
      );
    });
    if (hasBundle) return;
    var $url = document.querySelector('.as-highlights-replay-script');
    if (!$url) return;
    window.imageCards = $url.value;
    var $script = document.createElement('script');
    $script.src = $url.value;
    $script.defer = true;
    document.body.appendChild($script);
  }

  function isMobileHr() {
    return window.matchMedia('(max-width: 1000px)').matches;
  }

  function readVideoCfg(slide) {
    var tag = slide.querySelector('script.hr-replay-cfg');
    if (tag && tag.textContent) {
      try {
        var cfg = JSON.parse(tag.textContent.trim());
        return {
          sources: Array.isArray(cfg.sources) ? cfg.sources : [],
          external: cfg.external == null ? '' : String(cfg.external)
        };
      } catch (e) {}
    }
    var tpl = slide.querySelector('template.hr-replay-cfg');
    if (tpl && tpl.textContent) {
      try {
        var cfg2 = JSON.parse(tpl.textContent.trim());
        return {
          sources: Array.isArray(cfg2.sources) ? cfg2.sources : [],
          external: cfg2.external == null ? '' : String(cfg2.external)
        };
      } catch (e3) {}
    }
    var external = slide.getAttribute('data-hr-external-url') || '';
    var sourcesRaw = slide.getAttribute('data-hr-sources') || '[]';
    var sources = [];
    try {
      sources = JSON.parse(sourcesRaw);
    } catch (e2) {}
    return { sources: sources, external: external };
  }

  function mountVideo(slide) {
    if (slide.dataset.hrLoaded === '1') return;

    var customEmbed = slide.querySelector('[data-hr-custom-embed-root]');
    if (customEmbed) {
      slide.dataset.hrLoaded = '1';
      slide.classList.add('is-loaded');
      return;
    }

    var shopifyTpl = slide.querySelector('template.hr-shopify-video');
    if (shopifyTpl && shopifyTpl.content) {
      var fromTpl = shopifyTpl.content.querySelector('video');
      if (fromTpl) {
        slide.dataset.hrLoaded = '1';
        var video = fromTpl.cloneNode(true);
        video.classList.add('hr-slide__video');
        video.setAttribute('preload', 'metadata');
        slide.appendChild(video);
        slide.classList.add('is-loaded');
        tryPlay(video);
        return;
      }
    }

    var cfg = readVideoCfg(slide);
    var sources = cfg.sources || [];
    var external = cfg.external || '';
    if ((!sources || !sources.length) && !external) {
      return;
    }
    slide.dataset.hrLoaded = '1';
    var video = document.createElement('video');
    video.className = 'hr-slide__video';
    video.setAttribute('playsinline', '');
    video.setAttribute('controls', '');
    video.setAttribute('preload', 'metadata');
    if (sources.length) {
      sources.forEach(function (s) {
        if (!s) return;
        var u = s.url || s.src || s.playback_url;
        if (!u) return;
        var source = document.createElement('source');
        source.src = u;
        var mt = s.mime_type || s.mimeType || s.format;
        if (mt) source.type = mt;
        video.appendChild(source);
      });
    } else if (external) {
      var source = document.createElement('source');
      source.src = external;
      video.appendChild(source);
    }
    if (!video.querySelector('source')) {
      slide.dataset.hrLoaded = '0';
      return;
    }
    slide.appendChild(video);
    slide.classList.add('is-loaded');
    tryPlay(video);
  }

  function tryPlay(video) {
    if (!video || typeof video.play !== 'function') return;
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        video.muted = true;
        var p2 = video.play();
        if (p2 && typeof p2.catch === 'function') {
          p2.catch(function () {});
        }
      });
    }
  }

  function bindSlide(slide) {
    if (!slide || slide.dataset.hrBound === '1') return;
    slide.dataset.hrBound = '1';
    var activate = function () {
      mountVideo(slide);
    };

    slide.addEventListener('click', activate);
    if (!isMobileHr()) {
      slide.addEventListener('mouseenter', activate);
      slide.addEventListener('pointerenter', activate);
    }
  }

  function resetSlides(root) {
    root.querySelectorAll('[data-hr-slide]').forEach(function (s) {
      delete s.dataset.hrBound;
      delete s.dataset.hrLoaded;
      s.classList.remove('is-loaded');
      var v = s.querySelector('.hr-slide__video');
      if (v) v.remove();
    });
  }

  function patchHrSwiperCarousel(root) {
    var container = root.querySelector('.as-image-cards-container');
    if (!container) return;
    var swEl = container.querySelector('.swiper.as-swiper');
    if (!swEl) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      var swiper = swEl.swiper;
      if (swiper && swiper.scrollbar && swiper.scrollbar.el) {
        clearInterval(timer);
        if (swiper.__hrCarouselPatch) return;
        swiper.__hrCarouselPatch = true;

        var initIdx = parseInt(root.dataset.hrInitialSlide || '0', 10);
        if (!isNaN(initIdx) && initIdx > 0 && typeof swiper.slideTo === 'function') {
          try {
            swiper.update();
            swiper.slideTo(initIdx, 0, false);
          } catch (eSlide) {}
        }

        var EPS = 2;

        function syncNavAndScrollbar() {
          if (swiper.destroyed) return;
          swiper.update();
          var minT = swiper.minTranslate();
          var maxT = swiper.maxTranslate();
          var tr = swiper.translate;
          if (typeof maxT === 'number' && !isNaN(maxT) && tr < maxT - 0.25) {
            swiper.setTranslate(maxT);
          }
          if (typeof minT === 'number' && !isNaN(minT) && tr > minT + 0.25) {
            swiper.setTranslate(minT);
          }
          swiper.updateProgress();
          if (swiper.scrollbar && typeof swiper.scrollbar.updateSize === 'function') {
            swiper.scrollbar.updateSize();
          }
          if (swiper.navigation && typeof swiper.navigation.update === 'function') {
            swiper.navigation.update();
          }
          var tr2 = swiper.translate;
          var atEnd = tr2 <= maxT + EPS;
          var atStart = tr2 >= minT - EPS;
          var prev = container.querySelector('.as-swiper-arrow-prev');
          var next = container.querySelector('.as-swiper-arrow-next');
          if (prev) {
            prev.classList.toggle('swiper-button-disabled', atStart);
            prev.style.pointerEvents = atStart ? 'none' : '';
          }
          if (next) {
            next.classList.toggle('swiper-button-disabled', atEnd);
            next.style.pointerEvents = atEnd ? 'none' : '';
          }
        }

        var bar = swiper.scrollbar.el;
        var onBarPointer = function (e) {
          var drag = swiper.scrollbar.dragEl;
          if (!drag) return;
          if (e.target === drag || (drag.contains && drag.contains(e.target))) return;
          var dr = drag.getBoundingClientRect();
          var maxT = swiper.maxTranslate();
          var minT = swiper.minTranslate();
          var tr = swiper.translate;
          var atEnd = tr <= maxT + EPS;
          var atStart = tr >= minT - EPS;
          if (atEnd && e.clientX > dr.right - 1) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
          if (atStart && e.clientX < dr.left + 1) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        };
        ['pointerdown', 'mousedown', 'click'].forEach(function (evt) {
          bar.addEventListener(evt, onBarPointer, true);
        });

        swiper.on('slideChange transitionEnd resize', function () {
          requestAnimationFrame(syncNavAndScrollbar);
        });
        requestAnimationFrame(syncNavAndScrollbar);
        var rszTimer;
        window.addEventListener('resize', function () {
          clearTimeout(rszTimer);
          rszTimer = setTimeout(syncNavAndScrollbar, 120);
        });
      }
      if (tries > 100) clearInterval(timer);
    }, 50);
  }

  function initHrReplay(root) {
    if (!root) return;
    resetSlides(root);
    root.dataset.hrReplayInit = '1';
    root.querySelectorAll('[data-hr-slide]').forEach(bindSlide);
    patchHrSwiperCarousel(root);
  }

  function scan() {
    document.querySelectorAll('[data-hr-replay-root]').forEach(initHrReplay);
  }

  loadProductPromotionScript();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev && ev.target && ev.target.querySelector && ev.target.querySelector('[data-hr-replay-root]')) {
      ev.target.querySelectorAll('[data-hr-replay-root]').forEach(function (r) {
        initHrReplay(r);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders-new"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2-old"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v4"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-cs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-cards-script')
    if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
      window.imageCards = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.imageCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-promotion"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-product-promotion-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-product-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-secondary-product-cards-script');
    if (!window.secondaryProductCards && $url) {
      window.secondaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.secondaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }

    var $url2 = document.querySelector('.as-info-carousel-script');
    if (!window.infoCarousel && $url2) {
      window.infoCarousel = $url2.value;
      var $script = document.createElement('script');
      $script.src = window.infoCarousel;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-product-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-secondary-product-cards-script');
    if (!window.secondaryProductCards && $url) {
      window.secondaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.secondaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }

    var $url2 = document.querySelector('.as-info-carousel-script');
    if (!window.infoCarousel && $url2) {
      window.infoCarousel = $url2.value;
      var $script = document.createElement('script');
      $script.src = window.infoCarousel;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-product-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-secondary-product-cards-script');
    if (!window.secondaryProductCards && $url) {
      window.secondaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.secondaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }

    var $url2 = document.querySelector('.as-info-carousel-script');
    if (!window.infoCarousel && $url2) {
      window.infoCarousel = $url2.value;
      var $script = document.createElement('script');
      $script.src = window.infoCarousel;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-wl-featured-collection-script');
    if (!window.wlFeaturedCollection && $url && $url.dataset.designMode !== 'yes') {
      window.wlFeaturedCollection = $url.value;

      var $script = document.createElement('script');
      $script.src = window.wlFeaturedCollection;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-product-bundles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-secondary-product-cards-script');
    if (!window.secondaryProductCards && $url) {
      window.secondaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.secondaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }

    var $url2 = document.querySelector('.as-info-carousel-script');
    if (!window.infoCarousel && $url2) {
      window.infoCarousel = $url2.value;
      var $script = document.createElement('script');
      $script.src = window.infoCarousel;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }

    
  })();

  } catch(e) { console.error(e); }
})();
})();
